import { render } from "./MatchingGame.vue?vue&type=template&id=ddfc22c4&scoped=true&lang=html"
import script from "./MatchingGame.vue?vue&type=script&lang=js"
export * from "./MatchingGame.vue?vue&type=script&lang=js"

import "./MatchingGame.vue?vue&type=style&index=0&id=ddfc22c4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddfc22c4"]])

export default __exports__